import dayjs from "dayjs";

export const groupByField = (array: any[], key: string) => {
    const now = dayjs();
    const groups = {
        'Today': [] as any[],
        'Last week': [] as any[],
        'Last 30 days': [] as any[],
        'Beyond 30 days': [] as any[]
    };
    array.forEach(item => {
        const itemTime = dayjs(item[key]);
        const diffTime = now.diff(itemTime, 'millisecond');

        if (now.isSame(itemTime, 'day')) {
            groups.Today.push(item);
        } else if (diffTime < 7 * 24 * 60 * 60 * 1000) {
            groups["Last week"].push(item);
        } else if (diffTime < 30 * 24 * 60 * 60 * 1000) {
            groups["Last 30 days"].push(item);
        } else {
            groups["Beyond 30 days"].push(item);
        }
    });

    return groups;
};